import { useFormikContext } from 'formik';
import { ReactElement, useCallback, useEffect, useState } from 'react';
import { RightAlignedButtons } from '../../../../../../components/button/aligned-buttons';
import { BaseButton } from '../../../../../../components/button/base-button';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { useFlowServices } from '../../../hook/flow-service.hooks';
import {
  FlowItemForm,
  FlowItemParameterMetadata,
  FlowItemSharedRef,
} from '../../../model/flow.types';
import { getParametersFormWaitForTags } from '../../../util/flow-parameter.util';
import { ParametersList } from '../../flow-item-parameter/parameter-list';
import { TeachOptionsBaseProps } from '../teach.types';

export interface WaitForOptionProps extends TeachOptionsBaseProps {}

const WaitForOptions = (props: WaitForOptionProps): ReactElement => {
  const { onAdd } = props;

  const { flowItemService, system } = useFlowServices();
  const [parameters, setParameters] = useState<FlowItemParameterMetadata[]>([]);
  const { values } = useFormikContext<FlowItemForm>();

  const onChangeForm = useCallback(
    (form: FlowItemForm) => {
      const actualForm: FlowItemForm = form;
      const tags = getParametersFormWaitForTags(actualForm.parameters);

      const params = flowItemService.getParametersMetadataByTags(
        FlowItemSharedRef.WAIT_FOR,
        form.parameters,
        tags
      );

      setParameters(params);
    },
    [flowItemService]
  );

  useEffect(() => {
    onChangeForm(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(values), onChangeForm]);

  return (
    <>
      <ParametersList parameters={parameters} system={system} />

      {typeof onAdd === 'function' && (
        <RightAlignedButtons>
          <BaseButton
            buttonProps={{
              color: 'primary',
              onClick: (e) => {
                e.preventDefault();
                if (onAdd) {
                  onAdd(flowItemService.convertFormToFlowItem(values, system));
                }
              },
            }}
          >
            {getLocalizedText('common:add')}
          </BaseButton>
        </RightAlignedButtons>
      )}
    </>
  );
};

export { WaitForOptions };
